interface IUserCard {
  name: string;
  type: string;
  isNationalIdVerified?: boolean;
  image?: string;
  isDescriptionLtr?: boolean;
}

import styles from "./styles.module.scss";

const UserCard = ({
  name,
  type,
  image,
  isNationalIdVerified,
  isDescriptionLtr,
}: IUserCard) => {
  return (
    <div className={styles.container}>
      <div className={styles.image_container}>
        <img
          src={image || "/assets/images/user.png"}
          alt=""
          className={styles.image}
        />
        {isNationalIdVerified && (
          <img
            src="/assets/images/svg/verifiedIcon.svg"
            alt=""
            className={styles.id_verified_icon}
          />
        )}
      </div>
      <div className={styles.content}>
        <p className={styles.title}>{name}</p>
        <p
          className={styles.description}
          style={{
            direction: isDescriptionLtr ? "ltr" : "rtl",
            textAlign: isDescriptionLtr ? "end" : undefined,
          }}>
          {type}
        </p>
      </div>
    </div>
  );
};

export default UserCard;
